import { Dispatch, memo, SetStateAction, useCallback, useState } from 'react'

import { MobileSortBy, Table } from 'components/Table'
import { prettyLicenseDescription } from 'features/licenses/utils'
import type { LicenseType } from 'features/licenses/types'
import {
  HomeLicensesCollapseContainer,
  HomeLicensesGroupContainer,
  HomeLicensesGroupSummary,
  HomeLicensesTableInner,
  HomeLicensesTableOuter,
} from './styles'
import HomeLicensesGroupMobile from './HomeLicensesGroupMobile'
import { Column, SortingRule } from 'react-table'
import LicensesGroupHeading from 'features/licenses/components/LicensesGroupHeading'
import { TableHeader } from 'components/Table/types'

interface HomeLicensesGroupProps {
  columns: readonly Column<LicenseType>[]
  data: LicenseType[]
  defaultSortBy: SortingRule<LicenseType>
  sortBy: SortingRule<LicenseType>
  setSortBy: Dispatch<SetStateAction<SortingRule<LicenseType>>>
  sortOptions: SortingRule<LicenseType>[]
  headers: Record<string, TableHeader>
}

function HomeLicensesGroup({
  columns,
  data,
  defaultSortBy,
  sortBy,
  setSortBy,
  sortOptions,
  headers,
}: HomeLicensesGroupProps) {
  const [expand, setExpand] = useState(false)
  const [rowsCount, setRowsCount] = useState<number>()

  const getRowsCount = useCallback((count: number) => setRowsCount(count), [])

  const textForRowsCount = rowsCount && `${rowsCount} available`

  const collapse = () => setExpand(!expand)

  return (
    <HomeLicensesGroupContainer>
      <HomeLicensesGroupSummary onClick={collapse} collapse={expand}>
        <LicensesGroupHeading
          title={prettyLicenseDescription(data[0].description)}
          label={data[0].name}
          rowCount={textForRowsCount}
          chevronRotate={expand}
        />
      </HomeLicensesGroupSummary>

      <HomeLicensesCollapseContainer collapse={expand}>
        <HomeLicensesTableOuter>
          <HomeLicensesTableInner>
            <MobileSortBy
              headers={headers}
              sortOptions={sortOptions}
              sortBy={sortBy}
              setSortBy={setSortBy}
            />
            <Table
              columns={columns}
              data={data}
              defaultSortBy={defaultSortBy}
              rowsCountCallback={getRowsCount}
              mobileViewComponent={HomeLicensesGroupMobile}
              sortBy={sortBy}
              setSortBy={setSortBy}
            />
          </HomeLicensesTableInner>
        </HomeLicensesTableOuter>
      </HomeLicensesCollapseContainer>
    </HomeLicensesGroupContainer>
  )
}

export default memo(HomeLicensesGroup)
